import * as yasmina from '@/scenarios/yasmina/i18n';
import type { I18nDictionary } from '@/shared/lib/i18n';

const dictionaries: Record<symbol, I18nDictionary<any>> = {
    [yasmina.i18nNamespace]: yasmina.en,
};

export default dictionaries;
